import { render, staticRenderFns } from "./OfferTestResult.vue?vue&type=template&id=86822378"
import script from "./OfferTestResult.vue?vue&type=script&lang=js"
export * from "./OfferTestResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports